import * as React from 'react';
import { useParams } from 'react-router';

import { Col } from './generic/grid/col';
import { Row } from './generic/grid/row';
import TagCard from './TagCard';
import * as styles from './TagCard.style';

import type { Section } from '../types';

interface Props {
  sections: Section[];
}

// The front page: one card per section, two to a row as in the mockups.
const SectionsList = ({ sections }: Props): React.ReactElement | null => {
  const params = useParams();

  if (sections.length === 0) {
    return null;
  }

  return (
    <Row className="kb-section-list" style={styles.list}>
      {sections.map((section) => (
        <Col key={`section-${section.id}`} xs={12} sm={6} md={6} lg={6}>
          <TagCard tag={section} to={`/v/${params.hash}/c/${section.id}`} style={styles.sectionCard} />
        </Col>
      ))}
    </Row>
  );
};

export default SectionsList;
